export default "__VITE_ASSET__8Q1dTrGh__"